/**
 * @fileoverview Utility for determining referrer source based on URL patterns.
 * Used for analytics tracking across GA4 and Segment events.
 * @module referrerSource
 */

import { UrlSubdirectoryTypes } from "features/searchResultsFacets";

/**
 * Determines the source of the referrer based on URL patterns.
 * Categorizes referrers into known page types or returns the full referrer URL.
 * 
 * @param {string} referrer - The document referrer URL
 * @returns {string} The categorized referrer source: 'learning center nav', 
 * 'community page', 'plan page', 'spec page', 'direct', or the original referrer URL
 */
const determineReferrerSourceManufacturerPages = (referrer) => {
  if (!referrer) {
    return 'direct';
  }
  
  if (referrer.includes(`/${UrlSubdirectoryTypes.LearningCenter.toString()}/`)) {
    return 'learning center nav';
  }

  if (referrer.includes(`/${UrlSubdirectoryTypes.Community.toString()}/`)) {
    return 'community page';
  }

  if (referrer.includes(`/${UrlSubdirectoryTypes.Plan.toString()}/`)) {
    return 'plan page';
  }

  if (referrer.includes(`/${UrlSubdirectoryTypes.SpecDetail.toString()}/`)) {
    return 'spec page';
  }

  return referrer;
};

export default determineReferrerSourceManufacturerPages;